module.exports = __webpack_public_path__ + "img/signin-background.d34f9b95.png";